import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography';

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';

import Me from 'cityads-v3/containers/webmaster/profile/Me';

import classes from './HeaderToolbar.scss';

import { RootState } from 'cityads-v3/types/reducer';
import ButtonWithPopover from './ButtonWithPopover';
import { UserRoleCode } from 'cityads-v3/utils/authUtils';
import { Location } from 'history';

const ProfileLink: Record<UserRoleCode, string> = {
  [UserRoleCode.Manager]: '/main/manager/profile/me',
  [UserRoleCode.Webmaster]: '/publisher/profile/me',
  [UserRoleCode.Advertiser]: '',
  [UserRoleCode.AdvMadnet]: '',
}

type HeaderUserProps = {
  authLocation: string | Location
}

export default function HeaderUser({
  authLocation,
}: HeaderUserProps) {
  const { t } = useTranslation(['main'])
  const user = useSelector((state: RootState) => state.auth.user)
  const isMobile = useSelector((state: RootState) => state.app.isMobile)
  const owner = useSelector((state: RootState) => state.header.bar.filter(item => item.type === 'owner')[0])

  if (!user) {
    return (
      <Link
        id="headerLinkSignIn"
        className={classNames(classes.item, classes.itemLink, classes.itemSignIn)}
        to={authLocation}
      >
        {t('header.sign_in')}
      </Link>
    )
  }

  if (isMobile) {
    return (
      <Tooltip title={t('profile.me')}>
        <Link to={ProfileLink[user.user_role_code]}>
          <IconButton
            size="large"
          >
            <AccountCircleOutlinedIcon className={classes.headerIcon} />
          </IconButton>
        </Link>
      </Tooltip>
    );
  }

  return (
    <>
      <ButtonWithPopover
        popoverContent={<Me />}
      >
        <AccountCircleOutlinedIcon className={classNames(classes.headerIcon, classes.dropdownIcon)} />

        <Typography color="textPrimary" variant="caption" className={classes.dropdownItemText}>
          {user.email}
          {owner && owner.data && owner.data.sudo ? (
            ' | ' + owner.data.sudo.substr(0, owner.data.sudo.indexOf('@') + 1) + '…'
          ) : false}
        </Typography>
        <KeyboardArrowDownOutlinedIcon className={classes.arrowDown} />
      </ButtonWithPopover>
    </>
  );
}
